import { createContext, useContext, useEffect, useState } from "react";
import { setShowTest } from "@/lib/api";

const TestVisibilityContext = createContext(null);

const MASTER_KEY = "masandi_test_master";       // persistent Founder preference
const SESSION_KEY = "masandi_test_session";     // session-scoped quick toggle

export function TestVisibilityProvider({ children }) {
  const [master, setMaster] = useState(() => localStorage.getItem(MASTER_KEY) === "1");
  const [session, setSession] = useState(() => sessionStorage.getItem(SESSION_KEY) === "1");

  const effective = master || session;

  // keep the api client flag in sync so listing GETs append include_test
  useEffect(() => { setShowTest(effective); }, [effective]);

  const toggleSession = () => {
    const next = !effective ? true : false; // ON turns it on; OFF clears both
    if (next) {
      sessionStorage.setItem(SESSION_KEY, "1");
      setSession(true);
      setShowTest(true);
    } else {
      sessionStorage.removeItem(SESSION_KEY);
      setSession(false);
      // turning off via quick toggle also respects master: if master on, stays on
      if (!master) setShowTest(false);
    }
    setShowTest(next || master);
    window.location.reload();
  };

  const setMasterPref = (v) => {
    if (v) localStorage.setItem(MASTER_KEY, "1");
    else localStorage.removeItem(MASTER_KEY);
    setMaster(v);
    if (!v) { sessionStorage.removeItem(SESSION_KEY); setSession(false); }
    setShowTest(v);
    window.location.reload();
  };

  return (
    <TestVisibilityContext.Provider value={{ effective, master, session, toggleSession, setMasterPref }}>
      {children}
    </TestVisibilityContext.Provider>
  );
}

export const useTestVisibility = () => useContext(TestVisibilityContext);
